import { createFileRoute } from "@tanstack/react-router";
import {
  ColorPage,
  colorLoader,
  colorHeadEn,
  ColorErrorComponent,
  ColorNotFoundComponent,
} from "@/pages/ColorPage";

export const Route = createFileRoute("/en/farver/$slug")({
  loader: colorLoader,
  head: colorHeadEn,
  component: ColorPage,
  errorComponent: ColorErrorComponent,
  notFoundComponent: ColorNotFoundComponent,
});
